import { Type } from "./type";
import router from "@/routes";
import { authRepository } from "@/modules/auth/repositories";
import { DefaultClient } from "@/modules/auth/constant/client.default";
import { UserClient } from "@/modules/auth/constant/client.user";
import {
  UserClient as UserClientMock,
  DefaultClient as DefaultClientMock,
} from "@/modules/auth/constant/client.mock";
export const loginModule = {
  namespaced: true,
  state: () => ({
    login: {
      mobile: "",
      password: "",
    },
    user: {
      id: null,
      name: null,
      mobile: null,
      token: null,
    },
    shops: [],
  }),
  getters: {
    userInfo: (state) =>
      state.user.id
        ? state.user
        : JSON.parse(localStorage.getItem("user")) ?? null,
    shopList: (state) =>
      state.shops.length == 0
        ? { ...JSON.parse(localStorage.getItem("shops")) }.value
        : state.shops,
  },
  mutations: {
    [Type.LOGOUT](state) {
      localStorage.removeItem("user");
      state.user = {
        id: null,
        name: null,
        mobile: null,
        token: null,
      };
      if (!router.currentRoute.value.params["token"]) router.push("/auth");
      else router.push(`/${router.currentRoute.value.params["token"]}`);
    },
    [Type.RDIRECT_TO_LOGIN_SELLER](state, { payload, shops = [] }) {
      console.log("RDIRECT_TO_LOGIN_SELLER");
      state.shops = [...shops];
      localStorage.setItem("shops", JSON.stringify({ value: [...shops] }));
      router.push({
        path: "login-shop",
        query: {
          ...payload,
        },
      });
    },
    [Type.SUBMIT_LOGIN_SUCCESS](state, { token, role, user }) {
      console.log("SUBMIT_LOGIN_SUCCESS");
      console.log(token);
      Object.assign(state.user, { ...user, token, role });
      DefaultClient.defaults.headers.Authorization = `Bearer ${state.user.token}`;
      ///////
      DefaultClientMock.defaults.headers.Authorization = `Bearer ${state.user.token}`;
      UserClientMock.defaults.headers.Authorization = `Bearer ${state.user.token}`;
      /////////
      UserClient.defaults.headers.Authorization = `Bearer ${state.user.token}`;
      localStorage.setItem("user", JSON.stringify(state.user));
      console.log("def", DefaultClientMock.defaults.headers.Authorization);
      console.log("user", UserClientMock.defaults.headers.Authorization);
    },
  },
  actions: {
    async [Type.SUBMIT_LOGIN]({ commit }, payload) {
      let routeStorage;
      if (localStorage.getItem("routeStorage"))
        routeStorage = {
          ...JSON.parse(localStorage.getItem("routeStorage")),
        };
      try {
        const { data } = await authRepository.login(payload);
        if (data?.data?.result?.shops) {
          commit(Type.RDIRECT_TO_LOGIN_SELLER, {
            payload,
            shops: data?.data?.result?.shops,
          });
        } else if (routeStorage?.lastUserRoute) {
          commit(Type.SUBMIT_LOGIN_SUCCESS, data?.data?.result);
          router.push(`/${routeStorage.lastUserRoute}`);
        } else if (routeStorage?.BusinessToken) {
          commit(Type.SUBMIT_LOGIN_SUCCESS, data?.data?.result);
          router.push(`/${routeStorage.BusinessToken}`);
        } else if (router.currentRoute.value.query?.afterLogin) {
          commit(Type.SUBMIT_LOGIN_SUCCESS, data?.data?.result);
          router.push(`${router.currentRoute.value.query?.afterLogin}`);
        } else {
          commit(Type.SUBMIT_LOGIN_SUCCESS, data?.data?.result);
          router.go("/");
        }
      } catch (error) {
        console.error(error);
      }
    },
    async [Type.SUBMIT_LOGIN_SELLER]({ commit }, payload) {
      try {
        const { data } = await authRepository.loginSeller(payload.data);
        commit(Type.SUBMIT_LOGIN_SUCCESS, data?.data?.result);
        router.push(`/${payload.token}`);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
